import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ListItemIcon } from "@mui/material";
import { MenuItemStyled } from "@components/MainNavigation/Header/Header.styles";
import { useNavigationGuard } from "@context/NavigationGuardContext";
import { startScreenNavigation } from "@telemetry/navigationTiming";
import { useNavigate } from "react-router-dom";
import { NavigationMenuItemStyled, NavigationMenuStyled } from "./NavigationMenu.styles";

interface NavigationMenuItemProps {
  testId: string;
  label: string;
  menuId?: string;
  isActive: boolean | null;
  submenu: { title: string; path: string; testId: string; isVisible?: boolean }[] | undefined;
  isVisible: boolean;
  onClick?: () => void;
}

const NavigationMenuItem: React.FC<NavigationMenuItemProps> = ({
  testId,
  label,
  isActive,
  submenu = [],
  menuId,
  isVisible,
  onClick,
}) => {
  const navigate = useNavigate();
  const { requestNavigation } = useNavigationGuard();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isDropdownMenuOpen = Boolean(anchorEl);
  const hasDropdownMenu = submenu && submenu.length > 0;

  return isVisible ? (
    <>
      <NavigationMenuItemStyled
        key={testId}
        selected={isActive || undefined}
        data-testid={testId}
        color="inherit"
        onClick={(event) => {
          if (hasDropdownMenu) {
            setAnchorEl(event.currentTarget);
          } else if (onClick) {
            onClick();
          }
        }}
        aria-controls={isDropdownMenuOpen ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={isDropdownMenuOpen ? "true" : undefined}
      >
        {label}
        {hasDropdownMenu && (
          <ListItemIcon>
            <KeyboardArrowDownIcon />
          </ListItemIcon>
        )}
      </NavigationMenuItemStyled>
      {hasDropdownMenu && (
        <NavigationMenuStyled
          color="inherit"
          anchorEl={anchorEl}
          id={menuId}
          open={isDropdownMenuOpen}
          onClose={() => setAnchorEl(null)}
          onClick={() => setAnchorEl(null)}
          slotProps={{
            paper: {
              elevation: 0,
            },
          }}
          transformOrigin={{ horizontal: "left", vertical: "top" }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        >
          {submenu?.map(({ title, path, testId, isVisible }) =>
            isVisible ? (
              <MenuItemStyled
                key={testId}
                data-testid={testId}
                onClick={() => {
                  startScreenNavigation("Main Navigation", window.location.pathname, title);
                  requestNavigation(() => navigate(path));
                }}
              >
                {title}
              </MenuItemStyled>
            ) : null,
          )}
        </NavigationMenuStyled>
      )}
    </>
  ) : null;
};

export default NavigationMenuItem;
